import React from "react";
import { updateMetadata } from "actions/metadata";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FormActions from "components/FormActions";
import { Formik } from "formik";
import { METADATA_SCHEMA } from "constants/validation";
import ConnectedTextarea from "components/ConnectedTextarea";
import { useCtxReferences, useProductsPrices } from "utils/selectors";
import Analytics, { UPDATE_METADATA } from "utils/analytics";
import MetadataPreviewFields from "components/MetadataForm/Fields/MetadataPreviewFields";
import {
  getUpdateMetadataInitialValues,
  prepareUpdateMetadataValues
} from "utils/metadata";
import { UI_THEME } from "utils/constants/ui";
import { usePageBuilderContext } from "utils/context";
import get from "lodash/get";
import InfoNotice from "components/InfoNotice";
import { handleFormCb } from "utils/form";

const MetadataEdit = ({ actions, metadata, info, manifest }) => {
  const { products } = useProductsPrices();
  const { merchantAccount, resource, resourceUUID } = useCtxReferences();

  const pageBuilderContext = usePageBuilderContext();
  const tracking = get(pageBuilderContext, "tracking", {});
  const resourceIds = {
    resource,
    resourceUUID
  };

  const submitForm = (formValues, formikActions) => {
    const updatedMetadataData = prepareUpdateMetadataValues({
      values: formValues,
      metadata,
      products,
      merchantAccount
    });
    const updateInput = {
      ...resourceIds,
      uuid: metadata.uuid,
      data: updatedMetadataData
    };

    Analytics.track(UPDATE_METADATA, {
      tracking,
      metadata_id: metadata.id,
      ...resourceIds
    });

    actions.updateMetadata(updateInput, (err) =>
      handleFormCb(formValues, err, formikActions)
    );
  };

  const initialValues = getUpdateMetadataInitialValues({
    metadata,
    manifest,
    products
  });
  return (
    <Formik
      validationSchema={METADATA_SCHEMA}
      initialValues={initialValues}
      onSubmit={submitForm}
    >
      {() => (
        <div className="w-100">
          <FormActions
            theme={UI_THEME.SLIM}
            customClasses={{
              container: "w-100 flex flex-row items-center justify-end"
            }}
          />
          <MetadataPreviewFields />
          <div className="pt3">
            <InfoNotice {...info} />
          </div>
          {[
            <ConnectedTextarea name="title" label="Title" minRows={1} />,
            <ConnectedTextarea
              name="description"
              label="Description"
              minRows={1}
            />,
            <ConnectedTextarea
              name="twitter"
              label="Twitter"
              placeholder="@handle"
              minRows={1}
            />
          ].map((node, nodeIx) => (
            <div key={nodeIx} className="w-100 pt3">
              {node}
            </div>
          ))}
        </div>
      )}
    </Formik>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateMetadata
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(MetadataEdit);
